import HttpRequest from './http_request'
import * as dayjs from "dayjs";

class GenericProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT)
  }

  async copyCurriculumConstraints({ from_CURRICULUM_ID, to_CURRICULUM_ID }) {
    const { data } = await this.post('admission/api/', {
      function: 'copy-curriculum-constraint',
      from_CURRICULUM_ID,
      to_CURRICULUM_ID,
    })
    return data
  }


  async getCurrentYear(level_id) {
    const { data } = await this.get('admission/api/', {
      function: 'get-current-year',
      LEVEL_ID: level_id,
    })
    return data
  }

  async getFilteredCurriculumsForStudent(year_id) {
    const { data } = await this.get('admission/api/', {
      function: 'get-view',
      table: 'CONFIG_CURRICULUM',
      where: [
        { YEAR_ID: year_id },
        { END_APPLICATION_DATE: [">=", new dayjs().format('YYYY-MM-DD')] },
        { ENABLED: 1 },
      ],
      order: [
        { END_APPLICATION_DATE: 'ASC' }
      ]
    })
    return data
  }

  async getFilteredCurriculumsForStudentByLevelId(level_id) {
    const { data } = await this.get('admission/api/', {
      function: 'get-view',
      table: 'CONFIG_CURRICULUM',
      where: [
        { LEVEL_ID: level_id },
        { END_APPLICATION_DATE: [">=", new dayjs().format('YYYY-MM-DD')] },
        { ENABLED: 1 },
      ],
      order: [
        { END_APPLICATION_DATE: 'ASC' }
      ]
    })
    return data
  }

  async getCurriculumById(curriculum_id) {
    const { data } = await this.get('admission/api/', {
      function: 'get-view',
      table: 'CONFIG_CURRICULUM',
      where: [{ CURRICULUM_ID: curriculum_id }],
    })
    return data
  }

  async getCurriculumConstriantById(curriculum_id, constraint_id) {
    const { data } = await this.get('admission/api/', {
      function: 'get-view',
      table: 'CONFIG_CURRICULUM_CONSTRAINT',
      where: [{
        CURRICULUM_ID: curriculum_id,
        CONSTRAINT_ID: constraint_id,
      }],
    })
    return data
  }

  async dummie(user, key) {
    const { data } = await this.get('admission/cross-session.php', {
      user_id: user,
      key: key,
    })
    return data
  }

  async getRegistrarUserAccount() {
    const { data } = await this.get('api/user/', {
      function: 'get-registrar-user-account',
    })
    return data
  }
  // ############  gen student id
  async getRegistrarFaculty() {
    const { data } = await this.get('/api/faculty/', {
      function: 'get-registrar-faculty',
    })
    return data
  }

  async getRegistrarDepartment(faculty_id, department_id) {
    const { data } = await this.get('/api/department/', {
      function: 'get-registrar-department',
      faculty_id,
      department_id,
    })
    return data
  }

  async getRegistrarCurriculum(level_id, faculty_id, curriculum_id, department_id) {
    const { data } = await this.get('/api/curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }

  async genStudentId({ level, year, semester, mode, format }) {
    const { data } = await this.post('gen-student-id/generate.php', {
      level,
      year,
      semester,
      mode,
      format,
    })
    return data
  }
}

export default GenericProvider